import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 35px 0 15px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 70px 0 30px;
  }
`;

const Container = styled.div`
  margin: 0 auto;
  padding: 0 18px;
  max-width: 1140px;
`;

const Heading = styled.h1`
  font-size: 21px;
  line-height: 17px;
  color: #294f79;
  font-weight: 500;
  margin-bottom: 16px;

  @media (min-width: 768px) {
    font-size: 32px;
    line-height: 34px;
    margin-bottom: 24px;
  }
`;

const Tagline = styled.p`
  font-size: 13px;
  line-height: 22px;
  margin-bottom: 20px;
  max-width: 800px;
  margin: 0 auto 20px;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const Button = styled.button`
  text-transform: uppercase;
  background: #14b34f;
  color: #fff;
  border: 0;
  border-radius: 4px;
  font-size: 14px;
  box-shadow: 0 3px 1px rgba(0, 0, 0, 0.2);
  padding: 9px 60px;
  margin-bottom: 44px;
  width: 220px;
  cursor: pointer;

  @media (min-width: 768px) {
    padding: 17px 60px;
  }
`;

export { Wrapper, Container, Heading, Tagline, Button };
